import React, { useState, useCallback } from 'react';
import { TipWrapper, Text, Pointer, Container } from './elements';

type TipProps = {
  readonly className?: string;
  readonly text: string;
  readonly isBelow: boolean;
  readonly xPosition?: 'left' | 'center' | 'right';
  readonly showTip: boolean;
  readonly children: React.ReactElement;
};

export default function Tip({
  className,
  text,
  isBelow = false,
  xPosition = 'center',
  showTip = false,
  children,
}: TipProps) {
  const [tipDimensions, setTipDimensions] = useState<Partial<DOMRect>>({});
  const [childrenDimensions, setChildrenDimensions] = useState<
    Partial<DOMRect>
  >({});

  const tipRef = useCallback(
    node => {
      if (node !== null) {
        setTipDimensions(node.getBoundingClientRect());
      }
    },
    [text]
  );

  const wrapperRef = useCallback(
    node => {
      if (node !== null) {
        setChildrenDimensions(node.getBoundingClientRect());
      }
    },
    [children]
  );

  const yPositioning = tipDimensions.height + 6;

  const xPositioning = {
    left: isBelow ? 0 : childrenDimensions.width - 40,
    center: childrenDimensions.width / 2 - 20,
    right: isBelow ? childrenDimensions.width - 40 : 0,
  };

  return (
    <Container className={className}>
      <TipWrapper
        $showTip={showTip}
        ref={tipRef}
        $isBelow={isBelow}
        $yPositioning={`-${yPositioning}px`}
        $xPositioning={`${xPositioning[xPosition]}px`}
      >
        <Text>{text}</Text>
        <Pointer $isBelow={isBelow} />
      </TipWrapper>
      <div ref={wrapperRef}>{children}</div>
    </Container>
  );
}
